export const TickIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
            <path d="M0.500243 9.04517L5.2823 13.8272L15.5002 3.60927" stroke="currentColor" strokeLinecap="round" />
        </svg>
    );
};
